/**
 * @generated SignedSource<<677a497d4a568690b66a3000ebb22535>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodInfoStep_PaymentOptionConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly paymentMethod: {
        readonly id: string;
        readonly name: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodInfoContent_PaymentOption">;
    };
  }>;
  readonly " $fragmentType": "PaymentMethodInfoStep_PaymentOptionConnection";
};
export type PaymentMethodInfoStep_PaymentOptionConnection$key = {
  readonly " $data"?: PaymentMethodInfoStep_PaymentOptionConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodInfoStep_PaymentOptionConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodInfoStep_PaymentOptionConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentOptionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaymentOption",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentMethod",
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PaymentMethodInfoContent_PaymentOption"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PaymentOptionConnection",
  "abstractKey": null
};

(node as any).hash = "ab0846b1d20d8e743beafcf16b64111e";

export default node;
